import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'

import { readAdminSession } from '@/lib/auth/session-store'
import { AdminShell } from '@/components/shell/AdminShell'

export const Route = createFileRoute('/_admin')({
  beforeLoad: ({ location }) => {
    if (!readAdminSession()) {
      throw redirect({
        to: '/admin/login',
        search: { redirect: location.href },
      })
    }
  },
  component: AdminLayout,
})

function AdminLayout() {
  return (
    <AdminShell>
      <Outlet />
    </AdminShell>
  )
}
